import { AvailableRate } from '../types';

export const getTotalFromPricesForRates = (
  availableRates: (AvailableRate & {
    price_per_night?: { amount: number; currency_code: string };
    count: number;
  })[][]
) => {
  const ratePriceMap = new Map();
  availableRates.flat().forEach((rate) => {
    const currentTotal = ratePriceMap.get(rate.id) || {
      price_per_night: {
        ...rate.price_per_night,
        amount: rate.price_per_night ? 0 : undefined,
      },
      from_price: {
        ...rate.from_price,
        amount: 0,
      },
    };
    ratePriceMap.set(rate.id, {
      price_per_night: rate.price_per_night
        ? {
            ...rate.price_per_night,
            amount:
              currentTotal.price_per_night.amount +
              (rate.price_per_night?.amount || 0) * rate.count,
          }
        : undefined,
      from_price: {
        ...rate.from_price,
        amount: currentTotal.from_price.amount + (rate.from_price?.amount || 0) * rate.count,
      },
    });
  });
  return ratePriceMap;
};
